export default __webpack_public_path__ + "bb47f2c42e741e8c23ee9aa4d68b47cb.png";